<template>
  <div>
    <StepContent
      :theme="theme"
      :disable-grid="!invalidResponse && abTestGroup === 'B'"
    >
      <div
        v-if="!invalidResponse && abTestGroup === 'A'"
        class="contact-code__step-content"
      >
        <div
          class="contact-code-affiliate"
        >
          <component
            :is="affiliateLogo"
            class="contact-code-affiliate__logo"
          />
        </div>
        <p class="contact-code-affiliate__header">
          Welcome to <span class="text-blue-400">Spring Financial</span>
        </p>
        <br>
        <p class="contact-code-affiliate__subheader">
          We’ve partnered with {{ affiliateName }} to fulfill your loan request.
        </p>
        <br>
        <p class="contact-code__step-content-title">
          To continue, please enter the 4-digit code sent to your phone.
        </p>
        <div class="contact-code__step-content-text">
          <span class="mr-2">{{ customer.home_phone }}</span>
          <span
            class="contact-code__step-content-number"
            :class="textColorClass()"
            @click="$router.push({
              path: '/personal-loans/contact-phone',
              query: {...$route.query}
            })"
          >Change Number</span>
        </div>

        <AppInputWithValidation
          v-for="(field, index) in fields"
          :id="field.name"
          :key="index"
          :label="field.label"
          :name="field.name"
          :type="field.type"
          :mask="field.mask"
          :value="field.value"
          :max-length="field.maxLength"
          max-width="max-w-170"
          :rules="field.rules"
          :error="field.error"
          :placeholder-char="field.placeholderChar"
          :placeholder="field.placeholder"
          :hide-error="!submitted"
          verification-code
          :theme="theme"
          @input="handleInput($event, field.vuexAction)"
        />

        <div
          class="contact-code__resend-code"
        >
          <AppSpinner
            v-if="resendingCode"
            color="#00BED9"
          />
          <p
            v-else
            class="contact-code__text"
            :class="[resendTextStyles, computedTextStyles]"
            @click="resendCode"
          >
            {{ resendText }}
          </p>
        </div>

        <div>
          <AppCheckbox
            :theme="theme"
            class="xs:px-25"
            :value="consent"
            @input="handleCheckbox($event)"
          >
            <div class="text-xs text-left">
              Receive promotions and updates from Spring Financial. It’s free and you can opt out at any time.
              By clicking “continue” you agree to the             <a
                :class="textColorClass()"
                class="underline"
                :href="addTrackingParams(generalTermsOfServiceUrl)"
                target="_blank"
              >terms and conditions</a>
              and
              <a
                class="underline"
                :class="textColorClass()"
                :href="addTrackingParams(privacyPolicyUrl)"
                target="_blank"
              >privacy policy</a>.
            </div>
          </AppCheckbox>
        </div>

        <div
          v-if="maxResend"
          class="contact-code__max-resend"
        >
          <FontAwesomeIcon
            class="mr-5"
            icon="circle-exclamation"
          />
          <small>You have exceeded the maximum number of resend attempts. Please try again in 10 minutes.</small>
        </div>
      </div>

      <div
        v-else-if="!invalidResponse "
        class="contact-varB__step-content"
      >
        <div
          class="contact-varB-affiliate"
        >
          <img
            :src="require(`@/assets/img/loansCanadaVarB.svg`)"
            class="contact-varB-affiliate__logo"
            alt="Loans Canada"
            width="160"
            height="70"
          >
        </div>
        <p class="contact-varB-affiliate__header">
          <span class="text-[#EE3C37]">{{ affiliateName }}</span> Has<br class="flex sm:hidden"> Matched You
          With Spring Financial
        </p>
        <p class="contact-varB__step-content-title">
          <span class="font-semibold">Enter the code sent to your phone</span> to receive your loan offer.
        </p>
        <div class="contact-varB__step-content-text">
          <span class="font-semibold">{{ customer.home_phone }}</span>
        </div>

        <AppInputWithValidation
          v-for="(field, index) in fields"
          :id="field.name"
          :key="index"
          :label="field.label"
          :name="field.name"
          :type="field.type"
          :mask="field.mask"
          :value="field.value"
          :max-length="field.maxLength"
          max-width="max-w-170"
          :rules="field.rules"
          :error="field.error"
          :placeholder-char="field.placeholderChar"
          :placeholder="field.placeholder"
          :hide-error="!submitted"
          verification-code
          :theme="theme"
          :custom-class="!field.error && '!border-blue-400'"
          :error-position="'top'"
          @input="handleInput($event, field.vuexAction)"
        />

        <div
          class="contact-varB__resend-code"
        >
          <AppSpinner
            v-if="resendingCode"
            color="#00BED9"
          />
          <div
            v-else-if="showSent && resendCodeCounter > 0"
            class="contact-varB__message"
          >
            <b>A code has been sent to your phone.</b><br class="sm:hidden">
            <span>You can request a new code in:</span> <b class="text-[#08A187]">{{ resendCodeTimer }}s</b>
          </div>
        </div>

        <div>
          <AppCheckbox
            :theme="theme"
            class="max-w-550 mx-auto"
            :value="consent"
            @input="handleCheckbox($event)"
          >
            <div class="text-xs text-left">
              Receive promotions and updates from Spring Financial. It’s free and you can opt out at any time.
              By clicking “continue” you agree to the             <a
                :class="textColorClass()"
                class="underline"
                :href="addTrackingParams(generalTermsOfServiceUrl)"
                target="_blank"
              >terms and conditions</a>
              and
              <a
                class="underline"
                :class="textColorClass()"
                :href="addTrackingParams(privacyPolicyUrl)"
                target="_blank"
              >privacy policy</a>.
            </div>
          </AppCheckbox>
        </div>

        <div
          v-if="maxResend"
          class="contact-code__max-resend"
        >
          <FontAwesomeIcon
            class="mr-5"
            icon="circle-exclamation"
          />
          <small>You have exceeded the maximum number of resend attempts. Please try again in 10 minutes.</small>
        </div>
      </div>

      <ContactFailure v-else-if="invalidResponse" />
    </StepContent>

    <StepFooter
      :hide-mobile="abTestGroup === 'A'"
    >
      <AppButton
        :theme="theme"
        :loading="verifyingCode"
        @click="handleContinue"
      >
        Continue
      </AppButton>
      <div
        v-if="abTestGroup === 'B'"
        class="flex gap-4 justify-center items-center mt-30 font-bold"
      >
        <p
          class="contact-varB__text !text-[#404040]"
          :class="[resendTextStyles, computedTextStyles]"
          @click="resendCode"
        >
          Resend Code
        </p>
        <span
          class="contact-varB__step-content-number !text-[#404040]"
          @click="$router.push({
            path: '/personal-loans/contact-phone',
            query: {...$route.query}
          })"
        >Change Number</span>
      </div>
    </StepFooter>

    <ContactCodeAffiliatesFooterVarB v-if="abTestGroup === 'B'" />
    <ContactCodeAffiliatesFooter v-else />
  </div>
</template>

<script>
import AppCheckbox from '@/components/common/inputs/AppCheckbox'
import AppButton from '@/components/common/buttons/AppButton'
import AppInputWithValidation from '@/components/common/inputs/AppInputWithValidation'
import ContactCodeAffiliatesFooter from '@/components/steps/contact-code/ContactCodeAffiliatesFooter'
import ContactCodeAffiliatesFooterVarB from '@/components/steps/contact-code/ContactCodeAffiliatesFooterVarB'
import StepContent from '@/components/common/step-layout/StepContent'
import StepFooter from '@/components/common/step-layout/StepFooter'
import ContactFailure from '@/components/common/notifications/ContactFailure'
import AppSpinner from '@/components/common/spinners/AppSpinner'
import tracking from '@/mixins/tracking'

import NoRefusal from '@/components/svg/NoRefusal'
import Borrowell from '@/components/svg/Borrowell'
import LoansCanada from '@/components/svg/LoansCanada'
import LoanConnect from '@/components/svg/LoanConnect'
import ClearScore from '@/components/svg/ClearScore'
import SmarterLoans from '@/components/svg/SmarterLoans'
import Loanz from '@/components/svg/Loanz'
import Spring from '@/components/svg/Spring'
import BorrowellPrime from '@/components/svg/BorrowellPrime'
import LoanSpot from '@/components/svg/LoanSpot'
import Youdge from '@/components/svg/Youdge'

import input from '@/mixins/input'
import navigation from '@/mixins/navigation'
import buttonList from '@/mixins/button-list'
import submitLoans from '@/mixins/submit/submit-loans'
import DataLayer from '@/utilities/data-layer'
import theme from '@/mixins/theme'
import step from '@/mixins/step'
import submitMortgage from '@/mixins/submit/submit-mortgage'
import CryptoJS from 'crypto-js'

export default {
  name: 'ContactCode',

  // Components
  components: {
    AppButton,
    AppInputWithValidation,
    StepContent,
    StepFooter,
    ContactFailure,
    AppSpinner,
    AppCheckbox,
    ContactCodeAffiliatesFooter,
    ContactCodeAffiliatesFooterVarB,
    LoanSpot,
    Youdge
  },

  // Mixins
  mixins: [
    input,
    buttonList,
    navigation,
    submitLoans,
    theme,
    step,
    submitMortgage,
    tracking
  ],

  // Props
  props: {
    title: {
      type: String,
      default: 'How Can We Reach You?'
    }
  },

  // Data
  data () {
    return {
      verifyingCode: false,
      resendingCode: false,
      showSent: false,
      submitted: false,
      verificationStatus: '',
      invalidResponse: false,
      verificationExpired: false,
      maxResend: false,
      countdown: 30,
      consent: false,
      resendCodeCounter: 0
    }
  },

  // Computed
  computed: {
    phoneCodeError () {
      return this.$store.state.validations.phoneCodeError
    },

    generalTermsOfServiceUrl () {
      return `${process.env.VUE_APP_MINISITE_URL}general-terms-of-service`
    },

    privacyPolicyUrl () {
      return `${process.env.VUE_APP_MINISITE_URL}privacy-policy`
    },

    resendText () {
      return this.showSent ? '00:' + ('0' + this.countdown).slice(-2) : 'Resend'
    },

    resendCodeTimer () {
      return this.showSent ? ('0' + this.countdown).slice(-2) : '00'
    },

    resendTextStyles () {
      return {
        'underline cursor-pointer': !this.showSent || (this.resendCodeCounter === 0 && this.abTestGroup === 'B')
      }
    },

    computedTextStyles () {
      return this.showSent && this.resendCodeCounter ? ' pointer-events-none' : this.textColorClass()
    },

    customer () {
      return this.$store.state.customer
    },

    cduid () {
      return this.$store.state.customer.cduid
    },

    isDeeperPrepop () {
      return this.$store.state.application.isDeeperPrepop
    },

    bankStatements () {
      return this.$store.state.documents.bankStatements
    },

    fields () {
      return [{
        name: 'code',
        type: 'tel',
        value: this.customer.phoneVerificationCode,
        maxLength: 4,
        rules: this.phoneVerificationCodeRules,
        vuexAction: 'setVerificationCode',
        placeholder: '____',
        error: this.phoneCodeError
      }]
    },

    isVerificationStatusApproved () {
      return this.verificationStatus === 'approved'
    },

    isReturningCustomerInProgress () {
      return this.$store.state.returningCustomer.is_in_progress
    },

    phoneVerificationCodeRules () {
      return `required|digits:4|isVerified:${!this.failedToVerify}|verificationExpired:${!this.verificationExpired}`
    },

    failedToVerify () {
      return this.verificationStatus === 'pending' || this.verificationStatus === 'denied'
    },

    updateLeadPayload () {
      return {
        Twilio_Phone_Verified__c: true
      }
    },

    affiliateName () {
      const affiliateName = this.$store.state.application.affiliateName
      switch (affiliateName) {
        case 'loan-connect':
          return 'Loan Connect'
        case 'loanscanada':
          return 'Loans Canada'
        case 'springborrowell':
          return 'Borrowell'
        case 'clear-score':
          return 'ClearScore'
        case 'smarter-loans':
          return 'Smarter Loans'
        case 'loanz':
          return 'Loanz'
        case 'norefusal':
          return 'NoRefusal!'
        case 'loanspot':
          return 'LoanSpot'
        case 'youdge':
          return 'Youdge'
        default:
          return 'Affiliate Name'
      }
    },

    affiliateLogo () {
      const affiliateName = this.$store.state.application.affiliateName
      switch (affiliateName) {
        case 'loan-connect':
          return LoanConnect
        case 'loanscanada':
          return LoansCanada
        case 'springborrowell':
          if (this.$route.query['SID'] === 'springborrowellprime') return BorrowellPrime
          return Borrowell
        case 'clear-score':
          return ClearScore
        case 'smarter-loans':
          return SmarterLoans
        case 'loanz':
          return Loanz
        case 'norefusal':
          return NoRefusal
        case 'loanspot':
          return LoanSpot
        case 'youdge':
          return Youdge
        default:
          return Spring
      }
    },

    abTestGroup () {
      return this.$store.state.application.abTestLoansCanada
    }
  },

  // Watch
  watch: {
    $_navigation_triggerContinue: async function (val) {
      if (val) await this.handleContinue()
      this.$store.dispatch('setTriggerContinue', false)
    }
  },

  created () {
    // Preventing cx from resending verfication code for 30 sec
    this.showSent = true
    this.resendCountDownTimer()
  },

  mounted () {
    window.rudderanalytics.track('spring_ploan_deeper_prepop_page_landed')
    DataLayer.pushObject({ event: 'spring_ploan_deeper_prepop_page_landed' })
    const affiliateName = this.$store.state.application.affiliateName
    if ((this.isDeeperPrepop || this.isDeeperPrepopPrime) && affiliateName === 'loanscanada') {
      const group = localStorage.getItem('ab-test-loanscanada') || (Math.random() < 0.5 ? 'A' : 'B')
      if (!localStorage.getItem('ab-test-loanscanada')) {
        localStorage.setItem('ab-test-loanscanada', group)
      }
      this.$store.dispatch('setAbTestLoansCanada', group)

      const eventName = group === 'B' ? 'deeper_prepop_lc_handoff_varb' : 'deeper_prepop_lc_handoff_control'
      window.rudderanalytics.track(eventName)
      DataLayer.pushEvent('event', eventName)
    }
  },

  // Methods
  methods: {
    handleCheckbox (consent) {
      this.consent = +consent
      this.$store.dispatch('setConsentCEM', +this.consent)
    },

    handleInput ($event, vuexAction) {
      this.verificationStatus = ''
      this.$_input_updateState(vuexAction, $event)
      if (this.submitted) {
        this.$_navigation_validateStep()
      }
    },

    async resendCode () {
      // prevent spamming requests
      if (this.resendingCode) return false
      this.maxResend = false
      this.resendingCode = true
      this.verificationExpired = false
      this.resendCodeCounter += 1
      try {
        await this.$store.dispatch('requestVerification', {
          phone: this.customer.home_phone.replace(/[^0-9]/g, ''),
          channel: 'sms'
        })
        this.$store.dispatch('incrementVerificationAttempts')
      } catch (error) {
        // Server will return 429 for 10 minutes if code has been sent more than 5 times
        if (error.status && (error.status === 429 || error.status === '429')) {
          this.maxResend = true
          this.resendingCode = false
        }
      } finally {
        if (this.resendingCode) {
          this.resendingCode = false
          this.countdown = 30
          this.showSent = true
          this.resendCountDownTimer()
        }
      }
    },

    // Prevent Cx from sending request to Twilio and show them time they can resend it in
    resendCountDownTimer () {
      setTimeout(() => {
        if (this.countdown > 0) {
          this.countdown--
          this.resendCountDownTimer()
        } else {
          this.showSent = false
        }
      }, 1000)
    },

    async handleContinue () {
      // user clicks continue to submit verification code
      this.submitted = true
      if (this.verifyingCode) return false // prevent spamming requests

      if (this.invalidResponse) {
        if (this.$_navigation_isMortgage) await this.$_submit_mortgageLead()
        this.$_navigation_handleNext()
      } else {
        const isValid = await this.$_navigation_validateStep()
        if (!isValid) return
        await this.sendCodeVerificationRequest()
        if (!this.isVerificationStatusApproved) return

        if (!this.$_submit_leadCreated) {
          this.$_loans_createLead()
        } else if (this.bankStatements) {
          // push to verify idenetity
          return this.$router.push('/personal-loans/verify-identity')
        }

        if (this.$_navigation_isMortgage) await this.$_submit_mortgageLead()
        await this.$_step_handleContinue(this.updateLeadPayload)
      }
      this.verifyingCode = false
    },

    async sendCodeVerificationRequest () {
      const dataLayerObject = {
        event: `spring_${this.eventPrefix}_verification_code_inserted_continue`,
        sha256_phone_number: CryptoJS.SHA256(this.customer.home_phone).toString()
      }

      if (this.eventPrefix === 'ploan') {
        window.rudderanalytics.identify(this.customer.email, {
          phone_number: this.customer.home_phone,
          email: this.customer.email
        })

        window.rudderanalytics.track('spring_ploan_verification_code_inserted_continue')
      }
      DataLayer.pushObject(dataLayerObject)
      try {
        this.verifyingCode = true
        // call lambda middleware to check the verificaiton code with Twilio
        const verificationStatus = await this.$store.dispatch('checkVerification', {
          verificationSid: this.customer.phoneVerificationSid,
          code: this.customer.phoneVerificationCode
        })
        // Twilio response of approved|pending|denied
        this.verificationStatus = verificationStatus
        // submit lead if the code was approved
        if (this.verificationStatus === 'approved') {
          DataLayer.pushObject({ 'verification_successful': 1 })
          return
        }
        this.verifyingCode = false
        if (this.failedToVerify) {
          this.$store.dispatch('setPhoneCodeError', 'The code you entered is invalid. Please try again.')
        }

        // set an error message if the code is pending/denied
        // increment the failed attempts count and push to the datalayer
        this.$store.dispatch('incrementFailedVerifyAttempts')
        DataLayer.pushEvent('event', `spring_${this.eventPrefix}_verification_code_invalid`)
        DataLayer.pushObject({ verification_unsuccessful_continue: this.customer.failedVerificationAttempts })
      } catch (error) {
        if (error.status && (error.status === 503 || error.status === '503')) {
          // render ContactFailure component if Twilio/our service
          // is down to avoid losing a potential valid lead
          this.invalidResponse = true
        } else if (error.status && (error.status === 404 || error.status === '404')) {
          this.verificationExpired = true
          this.$store.dispatch('setPhoneCodeError', 'Your verification code has expired. Please click Resend to receive a new one.')
        }
        this.verifyingCode = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.contact-code {
  &__step-content {
    @apply text-center w-full max-w-500 m-auto;
  }

  &__step-content-title {
    @apply text-center inline-block text-md xs:text-lg sm:text-base;
  }

  &__step-content-text {
    @apply text-xs font-semibold mt-20 mb-20 xs:mb-30;

    @screen sm {
      @apply text-base mt-0 mb-40;
    }
  }

  &__step-content-number {
    @apply ml-2 underline cursor-pointer;
  }

  &__resend-code {
    @apply flex justify-center h-40;
  }

  &__max-resend {
    @apply text-red w-full;

    @screen md {
      @apply px-25;
    }
  }

  &-affiliate {
    @apply mb-30 flex justify-center;

    @screen xxs {
      @apply mb-20;
    }

    @screen xxs-only {
      @apply mb-10;
    }

    &__logo {
      @apply mx-auto text-2xl;
    }

    &__header {
      @apply font-heading text-xl xs:text-2xl font-semibold px-30 sm:px-0 xxs:text-lg;

      @screen xxs {
        @apply text-[22px] px-0;
      }
    }

    &__subheader {
      @apply text-md xs:text-lg sm:text-base;
    }
  }
}

.contact-varB {
  &__step-content {
    @apply text-center w-full max-w-750 m-auto sm:mt-20;
  }

  &__step-content-title {
    @apply text-center inline-block text-md sm:text-base;
  }

  &__step-content-text {
    @apply text-base font-semibold mt-[12px] mb-3 sm:mb-20 sm:mt-30;
  }

  &__step-content-number {
    @apply underline cursor-pointer;
  }

  &__resend-code {
    @apply flex justify-center min-h-40 my-10;
  }

  &__message {
    @apply sm:flex gap-x-1 items-center py-4 leading-xs sm:leading-[21px] text-[10px] font-semibold px-14 rounded-12;

    border: 1.5px solid rgba(0, 196, 161, 0.5);
    background: rgba(197, 255, 245, 0.5);
  }

  &__max-resend {
    @apply text-red w-full;

    @screen md {
      @apply px-25;
    }
  }

  &-affiliate {
    @apply flex justify-center;

    &__logo {
      @apply mx-auto w-[160px] h-[70px];
    }

    &__header {
      @apply font-heading font-semibold text-[24px] sm:text-[50px] leading-3 sm:leading-[55px] my-[18px] sm:my-40;
    }

    &__subheader {
      @apply text-md xs:text-lg sm:text-base;
    }
  }
}
</style>
